import {
  authHeader,
  handleResponse,
  handleWithClearErrorResponse,
} from "../_helpers";

const BASE_URL = process.env.REACT_APP_BASE_URL;

// Limited Release By Region
function getTargetGroupsByVirtual(queryParams) {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
  };
  const { groupId } = queryParams;
  const endPoint = `/api/admin/v1/groups/virtual/${groupId}`;

  return fetch(`${BASE_URL}${endPoint}`, requestOptions)
    .then(handleResponse)
    .then((data) => {
      return data;
    });
}

function createTargetGroupsByVirtual(requestBody) {
  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": "application/json", ...authHeader() },
    body: JSON.stringify(requestBody),
  };
  const endPoint = `/api/admin/v1/groups/virtual`;

  return fetch(`${BASE_URL}${endPoint}`, requestOptions)
    .then(handleWithClearErrorResponse)
    .then((data) => {
      return data;
    });
}

function editTargetGroupsByVirtual(requestBody, queryParams) {
  const requestOptions = {
    method: "PUT",
    headers: { "Content-Type": "application/json", ...authHeader() },
    body: JSON.stringify(requestBody),
  };
  const { groupId } = queryParams;
  const endPoint = `/api/admin/v1/groups/virtual/${groupId}`;

  return fetch(`${BASE_URL}${endPoint}`, requestOptions)
    .then(handleWithClearErrorResponse)
    .then((data) => {
      return data;
    });
}

function deleteTargetGroupsByVirtual(queryParams) {
  const requestOptions = {
    method: "DELETE",
    headers: { "Content-Type": "application/json", ...authHeader() },
  };
  const { groupId } = queryParams;
  const endPoint = `/api/admin/v1/groups/virtual/${groupId}`;

  return fetch(`${BASE_URL}${endPoint}`, requestOptions)
    .then(handleWithClearErrorResponse)
    .then((data) => {
      return data;
    });
}

export const targetGroupsVirtualService = {
  getTargetGroupsByVirtual,
  createTargetGroupsByVirtual,
  editTargetGroupsByVirtual,
  deleteTargetGroupsByVirtual,
};
